import React from "react";

const ApiContext = React.createContext({ apiData: [], setApiData: () => {} });

export default ApiContext;
